export default "__VITE_ASSET__DaO$Wmrb__"